<div class="floating-container">
    <mat-spinner *ngIf="isLoading && !isError" class="floating-spinner"></mat-spinner>
    <div *ngIf="!isLoading && !isError">
        <div class="logo-image-holder">
            <img src={{imageSource}} class="logo-image" onerror="this.src='assets/img/placeholder.png'">
        </div>
        <p class="floating-text">{{worktimeString}}</p>
        <div *ngIf="isSuccess">
            <div class="small-margin">
                <button mat-raised-button color="primary" class="fill-parent-width" (click)="orderNow()">{{orderNowString}}</button>
            </div>
            <div class="small-margin">
                <button *ngIf="showApp" mat-raised-button color="primary" (click)="openApp()" class="fill-parent-width">{{appButtonString}}</button>
            </div>
            <div class="small-margin">
                <button *ngIf="showProfile" mat-raised-button color="primary" (click)="seeProfile()" class="fill-parent-width">{{myProfileButtonString}}</button>
            </div>
        </div>
    </div>
    <div *ngIf="!isError" class="small-logo-holder" (click)="contactUs()">
        <img src="/assets/img/snacktimelogo.png" class="small-logo">
    </div>
    <div *ngIf="isError">
        <mat-card>
            <mat-card-header>
                <mat-card-title>{{errortitle}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>{{errormessage}}</p>
              </mat-card-content>
              <mat-card-actions>
                <button mat-raised-button color="accent" class="fill-parent-width" (click)="tryAgain()">{{errorbutton}}</button>
              </mat-card-actions>
        </mat-card>
    </div>
</div>